module.exports = __webpack_public_path__ + "img/pic_subject_history.5901344d.png";